<template>
  <div>
    <div class="apdex-label-header">
      {{ $t('healthIndicator') }}
    </div>

    <div class="apdex-label-status">
      <div class="apdex-status-indicator apdex-bg-good"></div>
      <div class="apdex-status-label-text apdex-color-good">
        {{ $t('good') }}
      </div>
      <div class="apdex-status-value-text apdex-color-good">
        {{ good[0] }}-{{ good[1] }}
      </div>
    </div>

    <div class="apdex-label-status">
      <div class="apdex-status-indicator apdex-bg-fair"></div>
      <div class="apdex-status-label-text apdex-color-fair">
        {{ $t('fair') }}
      </div>
      <div class="apdex-status-value-text apdex-color-fair">
        {{ fair[0] }}-{{ fair[1] }}
      </div>
    </div>

    <div class="apdex-label-status">
      <div class="apdex-status-indicator apdex-bg-poor"></div>
      <div class="apdex-status-label-text apdex-color-poor">
        {{ $t('poor') }}
      </div>
      <div class="apdex-status-value-text apdex-color-poor">
        {{ poor[0] }}-{{ poor[1] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    good: {
      type: Array,
      default: () => [0, 0],
    },
    fair: {
      type: Array,
      default: () => [0, 0],
    },
    poor: {
      type: Array,
      default: () => [0, 0],
    },
  },
};
</script>

<style lang="scss" scoped>
.apdex-label-header {
  @include flex-center-vert;
  padding: 0.5rem 0rem 0.5rem 1rem;
  border-top: 0.0063em solid $border-primary;
  margin-top: 1rem;
}
.apdex-status-indicator {
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
}
.apdex-label-status {
  @include flex-center-vert;
  margin-top: 0.5rem;
  margin-left: 3rem;
}
.apdex-status-label-text {
  margin-left: 0.5rem;
  font-size: 1.125rem;
  width: 3.25rem;
  text-align: left;
}
.apdex-status-value-text {
  margin-left: 0.5rem;
  font-size: 1.125rem;
}
.apdex-bg-good {
  background-color: $good;
}
.apdex-bg-fair {
  background-color: $fair;
}
.apdex-bg-poor {
  background-color: $poor;
}
.apdex-color-good {
  color: $good;
}
.apdex-color-fair {
  color: $fair;
}
.apdex-color-poor {
  color: $poor;
}
</style>
